import loadable from '@loadable/component';

export const NewbuildingsFromDeveloperLoadable = loadable(() => import('./NewbuildingsFromDeveloperContainer'), {
  ssr: false,
  resolveComponent: ({ NewbuildingsFromDeveloperContainer }) => NewbuildingsFromDeveloperContainer,
});
